import React, { useState } from "react";
import { format, addDays } from "date-fns";
import CommonFilterStructure from "../../../components/common-components/CommonFilterStructure";

const APESfilters = ({
  filters,
  setFilters,
  onClickReset,
  searchFilterApplied,
  onClickSearch,
  user,
  apesDate,
  prevGymId
}) => {
  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setFilters({
      ...filters,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setFilters({
      ...filters,
      selectedStartDate: "",
      selectedEndDate: "",
    });
  };

  return (
    <CommonFilterStructure
      from={"active_pt_with_expired_subscription"}
      decryptedText={user}
      filters={filters}
      setFilters={setFilters}
      onClickReset={onClickReset}
      searchFilterApplied={searchFilterApplied}
      onClickSearch={onClickSearch}
      openDateRanger={openDateRanger}
      handleDateRangeChange={handleDateRangeChange}
      setOpenDateRanger={setOpenDateRanger}
      rangeState={rangeState}
      clearDateRanger={clearDateRanger}
      apesDate={apesDate}
      prevGymId={prevGymId}
    />
  );
};

export default APESfilters;
